<script lang="ts">
	//UI
	import Title from "@hitit/hub/src/v7/components/notice/Title.svelte";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import { SearchInput, Pagenation, NoticeStyleLink } from "@hitit/new_ui/src";
	//Utils
	import querystring from "query-string";
	import { api, t } from "@hitit/hub/src/stores";
	import { newAlert } from "../store";
	import { navigate } from "svelte-routing";
	import { globalHistory } from "svelte-routing/src/history";
	import { processingDate } from "../utils";
	import type { NewsListDTOList } from "@hitit/api";
	//Types
	type locationOverload = { search: string; pathname: string };
	//Props

	//Constants
	const theFirstQuery = parseQuerystring(window.location.search);
	//Variables

	let loading = false;
	let notices: NewsListDTOList[] = [];
	let temporarySearchText = "";
	let searchText = theFirstQuery.search;
	let presentPage = theFirstQuery.page;
	let totalPage = theFirstQuery.page;
	let totalElements = 0;
	//Functions
	const formSubmitHandler = (text: string) =>
		navigate(`/notice?search=${text}&page=0`);
	const pagenationClickHandler = (page: number) =>
		navigate(`/notice?search=${searchText}&page=${page}`);

	async function getNoticeList(search = "", page = 0) {
		try {
			loading = true;

			const { data } = await $api.getNewsDocumentList(
				search,
				page,
				undefined,
				false
			);

			notices = data.newsListDTOList;
			totalElements = data.totalElements;
			totalPage = data.totalPages;
		} catch (error) {
			//
		} finally {
			loading = false;
		}
	}

	function parseQuerystring(query: string) {
		const parsed = querystring.parse(query);
		const { search, page } = parsed;

		return {
			search: (search || "") as string,
			page: Number(page) || 0,
		};
	}

	globalHistory.listen((v) => {
		const query = parseQuerystring((v.location as locationOverload).search);
		searchText = query.search;
		presentPage = query.page;
	});

	//Do
	$: getNoticeList(searchText, presentPage);
</script>

{#if loading}
	<ContainerLoading />
{/if}
<div class="container" id="notice-container">
	<div class="header">
		<Title />
		<form
			on:submit|preventDefault={() => formSubmitHandler(temporarySearchText)}
		>
			<SearchInput
				bind:value={temporarySearchText}
				placeholder={$t("global.search_article")}
			/>
		</form>
	</div>
	<div class="body">
		<ul class="list">
			{#each notices as notice}
				<NoticeStyleLink
					title={notice.title}
					date={processingDate(notice.publishedDate, "yyyy.MM.DD")}
					read={Boolean(notice.readDate)}
					linkHref={`/notice/${notice.id}`}
				/>
			{/each}
		</ul>
		{#if totalElements}
			<Pagenation
				presentPage={presentPage}
				totalPage={totalPage}
				buttonCallback={pagenationClickHandler}
			/>
		{/if}
	</div>
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		padding-top: 50px;
		display: flex;
		flex-direction: column;
		gap: 20px;

		.header {
			display: flex;
			flex-direction: column;
			width: 100%;
			gap: 20px;
			form {
				width: 100%;
			}
		}
		.body {
			display: flex;
			flex-direction: column;
			gap: 20px;

			.list {
				list-style: none;
				display: flex;
				flex-direction: column;
				gap: 10px;
			}
		}
	}
	@include DesktopSize {
		.container {
			gap: 30px;
			padding-top: 30px;

			.header {
				gap: 30px;
				form {
					max-width: 787px;
				}
			}
			.body {
				gap: 30px;

				.list {
					gap: 20px;
				}
			}
		}
	}
</style>
